// extracted by mini-css-extract-plugin
module.exports = {"container":"plans_container__37Yxt","section-title":"plans_section-title__2kLD_","radio-form":"plans_radio-form__1vc4p"};